export const ORIGENS_ERRO = ['manual', 'vue', 'javascript', 'navegacao', 'http', 'legado', 'i18n', 'flagsmith'] as const
export const OPERACOES_ERRO = ['captura', 'inicializacao', 'navegacao', 'requisicao', 'traducao', 'modulos', 'funcionalidades', 'consultar_tamanho_cliente'] as const
export const NATUREZAS_FALHA = ['http', 'rede', 'timeout', 'resposta_invalida', 'desconhecida'] as const
// Códigos de transporte conhecidos; nunca códigos livres devolvidos pelo backend.
export const CODIGOS_TECNICOS_ERRO = ['ERR_BAD_REQUEST', 'ERR_BAD_RESPONSE', 'ERR_NETWORK', 'ETIMEDOUT', 'ECONNABORTED', 'ERR_INVALID_URL', 'ERR_BAD_OPTION', 'ERR_BAD_OPTION_VALUE', 'ERR_NOT_SUPPORT', 'ERR_FR_TOO_MANY_REDIRECTS'] as const

export type ContextoErro = Readonly<{
  origem: typeof ORIGENS_ERRO[number]
  operacao?: typeof OPERACOES_ERRO[number]
  categoria?: 'inesperado' | 'cancelamento' | 'validacao' | 'qualidade'
  statusHttp?: number
  naturezaFalha?: typeof NATUREZAS_FALHA[number]
  codigoTecnico?: typeof CODIGOS_TECNICOS_ERRO[number]
  metodoHttp?: string
  servicoHttp?: string
  servidorHttp?: string
  /** Caminho chamado, sem query/hash na saída. Sem modelo, entra normalizado na deduplicação. */
  endpoint?: string
  /** Modelo conhecido pelo fluxo, por exemplo /funcionarios/:id; nunca inferido de IDs. */
  endpointModelo?: string
  /** Detalhes conhecidos da resposta, separados da exceção técnica e de sua stack. */
  mensagemApi?: string
  codigoApi?: string
  requestId?: string
  origemStack?: 'original' | 'causa' | 'captura'
}>

/** Identidade da sessão atual, fornecida pela aplicação sem expor sua store. */
export type IdentidadeObservabilidade = Readonly<{
  usuario: Readonly<{ id: string; email?: string }>
  empresa?: Readonly<{ id: string; nome?: string }>
}>

export interface Observabilidade {
  registrarErro(erro: unknown, contexto: ContextoErro): void
}

export const CHAVE_OBSERVABILIDADE: InjectionKey<Observabilidade> = Symbol('observabilidade')

/** Construir e fornecer a porta não instala handlers nem produz diagnóstico. */
export const criarObservabilidadeDesativada = (): Observabilidade => ({
  registrarErro: () => undefined,
})
import type { InjectionKey } from 'vue'
